<template>
  <div>
    <info-msg v-if="question.result === 0" message="There are no measured products for this office." />
    <div v-else>
      <div>
        <div class="px-4 pb-4">
          <div class="flex flex-wrap -mx-3 items-center">
            <div class="w-4/5 justify-start items-start">
              {{ question.title }}
            </div>
          </div>
        </div>
        <div class="overflow-auto w-full">
          <table class="text-sm w-full border">
            <thead>
            <tr class="text-xs">
              <th>Active Products</th>
              <th class="text-center py-8">Last Review Status</th>
              <th class="text-center py-8">Engagement</th>
            </tr>
            </thead>
            <tbody v-if="scorecard_flag">
            <tr v-for="(product, tag) in question.result" :key="tag" v-if="tag !== 'data' && product.active">
              <td class="text-left py-4 px-4">{{product.label}}</td>
              <td class="text-center py-2" v-if="question.previous_value && question.previous_value[tag]" :title="question.previous_value[tag].title">
                <div v-if="question.previous_value[tag].flag === 'good'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-green-lighter text-green">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-grey text-grey-dark">
                  <i class="fas fa-times"></i>
                </div>
              </td><td v-else></td>
              <td class="text-center py-2" :title="product.title">
                <div v-if="product.flag === 'good'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-green-lighter text-green">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-grey text-grey-dark">
                  <i class="fas fa-times"></i>
                </div>
              </td>
            </tr>
            <tr class="bg-grey-lighter">
              <td></td>
              <td class="text-center whitespace-no-wrap font-black text-xl py-4">
                <div class="text-right w-3/4 mr-4" v-if="question.previous_value && question.previous_value.data">
                  {{ question.previous_value.data.total_active_points | number }} pts
                  <small class="block">{{ question.previous_value.data.active_products_count | number }}/{{ question.previous_value.data.total_active_products | number }} products</small>
                </div>
              </td>
              <td class="text-center whitespace-no-wrap font-black text-xl flex justify-end py-4" :class="points_percentage >= greenThreshhold ? 'bg-green text-green-dark' : (points_percentage >= amberThreshhold ? 'bg-yellow text-yellow-dark' : 'bg-red-lighter text-red')">
                <div class="uppercase text-lg ml-4">Score</div>
                <div class="text-right w-3/4 mr-4" v-if="question.result && question.result.data">
                  {{ question.result.data.total_active_points | number }} pts
                  <small class="block text-gray-500">{{ question.result.data.active_products_count | number }}/{{ question.result.data.total_active_products | number }} products</small>
                </div>
                <div class="text-right w-3/4 mr-4" v-else>
                  0 pts
                  <small class="block text-gray-500">0/0 products</small>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr v-for="(product, tag) in question.result" :key="tag" v-if="tag !== 'data' && product.active">
              <td class="text-left">{{product.label}}</td>
              <td class="text-center">-</td>
              <td class="text-center">-</td>
            </tr>
            </tbody>
          </table>
          <div class="flex items-center justify-end mt-4" v-if="scorecard_flag">
            <div class="px-3 w-1/5 text-sm self-end">
              <h4 class="text-xs uppercase font-bold">Engagement</h4>
              <div><i class="fas fa-check-circle text-green-600"></i> Good Engagement</div>
              <div><i class="fas fa-check-circle text-yellow-600"></i> Low Engagement</div>
              <div><i class="fas fa-check-circle text-red-600"></i> Poor Engagement</div>
              <div><i class="fas fa-times-circle text-gray-600"></i> Inactive</div>
            </div>
          </div>
          <table class="text-sm w-full border mt-8">
            <thead>
            <tr class="text-xs">
              <th>Products Engagement</th>
              <th class="text-center py-8">Last Review Status</th>
              <th class="text-center py-8">Engagement</th>
            </tr>
            </thead>
            <tbody v-if="scorecard_flag">
            <tr v-for="(product, tag) in question.result" :key="tag" v-if="tag !== 'data' && product.engagement">
              <td class="text-left py-4 px-4">{{product.label}}</td>
              <td class="text-center py-2" v-if="question.previous_value && question.previous_value[tag]" :title="question.previous_value[tag].title">
                <div v-if="question.previous_value[tag].flag === 'good'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-green-lighter text-green">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else-if="question.previous_value[tag].flag === 'low'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-yellow-lighter text-yellow-dark">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else-if="question.previous_value[tag].flag === 'poor'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-red-lighter text-red">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-grey text-grey-dark">
                  <i class="fas fa-times"></i>
                </div>
              </td><td v-else></td>
              <td class="text-center py-2" :title="product.title">
                <div v-if="product.flag === 'good'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-green-lighter text-green">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else-if="product.flag === 'low'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-yellow-lighter text-yellow-dark">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else-if="product.flag === 'poor'" class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-red-lighter text-red">
                  <i class="fas fa-check"></i>
                </div>
                <div v-else class="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-grey text-grey-dark">
                  <i class="fas fa-times"></i>
                </div>
              </td>
            </tr>
            <tr class="bg-grey-lighter">
              <td></td>
              <td class="text-center whitespace-no-wrap font-black text-xl py-4">
                <div class="text-right w-3/4 mr-4" v-if="question.previous_value && question.previous_value.data">
                  {{ question.previous_value.data.total_engagement_points | number }} pts
                  <small class="block">{{ question.previous_value.data.engagement_products_count | number }}/{{ question.previous_value.data.total_engagement_products | number }} products</small>
                </div>
              </td>
              <td class="text-center whitespace-no-wrap font-black text-xl flex justify-end py-4" :class="points_percentage >= greenThreshhold ? 'bg-green text-green-dark' : (points_percentage >= amberThreshhold ? 'bg-yellow text-yellow-dark' : 'bg-red-lighter text-red')">
                <div class="uppercase text-lg ml-4">Score</div>
                <div class="text-right w-3/4 mr-4" v-if="question.result && question.result.data">
                  {{ question.result.data.total_engagement_points | number }} pts
                  <small class="block text-gray-500">{{ question.result.data.engagement_products_count | number }}/{{ question.result.data.total_engagement_products | number }} products</small>
                </div>
                <div class="text-right w-3/4 mr-4" v-else>
                  0 pts
                  <small class="block text-gray-500">0/0 products</small>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr v-for="(product, tag) in question.result" :key="tag" v-if="tag !== 'data' && product.engagement">
              <td class="text-left">{{product.label}}</td>
              <td class="text-center">-</td>
              <td class="text-center">-</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object
    },
    scorecard_flag: {
      default: true,
      type: Boolean
    }
  },
  data: function () {
    return {
      question: this.value,
      greenThreshhold: 61,
      amberThreshhold: 30
    }
  },
  computed: {
    points_percentage () {
      return this.question.result ? (100 / this.question.result.data.max_points) * this.question.result.data.total_points : 0
    }
  }
}
</script>
